/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Image_Viewer_Regenerate_SubmitInputs */



/**
* | output |
* | --- |
* | "Generate" |
*
* @param {Chat_Image_Viewer_Regenerate_SubmitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_image_viewer_regenerate_submit = /** @type {((inputs?: Chat_Image_Viewer_Regenerate_SubmitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Image_Viewer_Regenerate_SubmitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erzeugen")
	return /** @type {LocalizedString} */ ("Generate")
});